//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapState} from 'vuex'
export default {
    props: {
        'noLogin':{
            type: Boolean,
            default: false
        },
        'isIOSApp':{
            type: Boolean,
            default: false
        },
        'noWeixin':{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
    computed: {
        ...mapState(['isMobile']),
    },
    methods: {
        weiboLogin() {
            LOGIN.loginWeibo()
        },
        loginQQ() {
            LOGIN.loginQQ()
        },
        loginWeixin() {
            LOGIN.loginWeixin(location.href)
        },
        normalLogin() {
            this.$router.push({ path: '/normalLogin' })
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/homeLogin.vue